import React from 'react';
import { useRole } from '../hooks/useRole';

/**
 * Role guard in front of the Asoebi screens (Fabrics, Orders, Bundles).
 *
 * The server is the authority: it refuses every Asoebi write from a viewer
 * and nulls money for a financially blind role. This gate makes the screen
 * say so instead of showing buttons that would only fail:
 *  - below planner level (a viewer) the screens are not shown at all, the same
 *    floor the sidebar entry has, so nobody reaches a write button by URL;
 *  - a financially blind role (contractor, or anyone flagged blind) sees the
 *    screens with a notice that prices and payments are hidden for them.
 */
const AsoebiAccessGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { canEdit, canViewFinancials } = useRole();

  if (!canEdit) {
    return (
      <div className="alert alert-warning" role="status">
        Asoebi is available to planners and above. Ask the project owner if you need access.
      </div>
    );
  }

  return (
    <>
      {!canViewFinancials && (
        <div className="alert alert-warning" role="status">
          Prices, payments and totals are hidden for your role. Amounts shown as zero or a dash are not real figures.
        </div>
      )}
      {children}
    </>
  );
};

export default AsoebiAccessGate;
